// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__JlBZG","Initials":"Avatar_Initials__uBUsH Avatar_Avatar__JlBZG","Small":"Avatar_Small__Usn47"};